// import { Flex, Divider, useColorModeValue, Box } from '@chakra-ui/react';
// import React from 'react';

// import config from 'configs/app';
// import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';

// import DeFiDropdown from './DeFiDropdown';
// import NetworkMenu from './NetworkMenu';
// import Settings from './settings/Settings';
// import TopBarStats from './TopBarStats';

// const TopBar = () => {
//   const bgColor = useColorModeValue('gray.50', 'whiteAlpha.100');

//   return (
//     <Box bgColor={ bgColor }>
//       <Flex
//         py={ 2 }
//         px={{ base: 3, lg: 6 }}
//         maxW={ `${ CONTENT_MAX_WIDTH }px` }
//         m="0 auto"
//         justifyContent="space-between"
//         alignItems="center"
//       >
//         <TopBarStats/>
//         <Flex alignItems="center">
//           { config.features.deFiDropdown.isEnabled && (
//             <>
//               <DeFiDropdown/>
//               <Divider mr={ 3 } ml={{ base: 2, sm: 3 }} height={ 4 } orientation="vertical"/>
//             </>
//           ) }
//           <Settings/>
//           { config.UI.navigation.layout === 'horizontal' && Boolean(config.UI.navigation.featuredNetworks) && (
//             <Box display={{ base: 'none', lg: 'flex' }}>
//               <Divider mx={ 3 } height={ 4 } orientation="vertical"/>
//               <NetworkMenu/>
//             </Box>
//           ) }
//         </Flex>
//       </Flex>
//     </Box>
//   );
// };

// export default React.memo(TopBar);

import { Box, Button, Flex, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';

import config from 'configs/app';
import { useI18n } from 'lib/i18n/context';
import IconSvg from 'ui/shared/IconSvg';
import SearchBar from 'ui/snippets/searchBar/SearchBar';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

import LanguageSwitcher from './LanguageSwitcher';
import TopBarStats from './TopBarStats';

const TopBar = () => {
  const router = useRouter();
  const { colorMode, toggleColorMode } = useColorMode();
  const { t } = useI18n();
  const topBarBg = useColorModeValue('#FFFFFF', '#111111');
  const borderColor = useColorModeValue('#E9ECEF', '#222222');
  const actionBg = useColorModeValue('#FBFCFE', '#171717');
  const actionColor = useColorModeValue('#000000', '#FFFFFF');
  const shouldShowSearchBar = router.pathname !== '/';

  return (
    <Flex
      display={{ base: 'none', lg: 'flex' }}
      position="sticky"
      top={ 0 }
      zIndex="sticky"
      alignItems="center"
      justifyContent="space-between"
      bg={ topBarBg }
      borderBottom="1px solid"
      borderColor={ borderColor }
      px="24px"
      py="8px"
      minH="56px"
      gap="24px"
    >
      <Flex alignItems="center" gap="24px" minW={ 0 } flex={ 1 }>
        <Box flexShrink={ 0 }>
          <TopBarStats/>
        </Box>
        { shouldShowSearchBar ? (
          <Box flex={ 1 } minW={ 0 } display="flex" justifyContent="flex-end">
            <Box width="100%" maxW="864px">
              <SearchBar/>
            </Box>
          </Box>
        ) : <Box flex={ 1 }/> }
      </Flex>
      <Flex alignItems="center" gap="16px" flexShrink={ 0 }>
        <Button
          aria-label={ t('topBar.toggleColorMode') }
          onClick={ toggleColorMode }
          minW="40px"
          h="40px"
          p="10px"
          borderRadius="8px"
          border="1px solid"
          borderColor={ borderColor }
          bg={ actionBg }
          color={ actionColor }
          _hover={{ bg: actionBg }}
        >
          <IconSvg name={ colorMode === 'dark' ? 'moon' : 'sun' } boxSize={ 5 }/>
        </Button>
        <LanguageSwitcher/>
        { config.features.account.isEnabled ? (
          <UserProfileDesktop buttonVariant="hero"/>
        ) : null }
        { !config.features.account.isEnabled && config.features.blockchainInteraction.isEnabled ? (
          <UserWalletDesktop buttonVariant="hero"/>
        ) : null }
      </Flex>
    </Flex>
  );
};

export default React.memo(TopBar);
